import { __rest as e } from "tslib";
import * as r from "react";
import { getErrors as t } from "@aws-amplify/ui";
import { PasswordField as o } from "../../../primitives/PasswordField/PasswordField.js";
import { PhoneNumberField as i } from "../../../primitives/PhoneNumberField/PhoneNumberField.js";
import { TextField as a } from "../../../primitives/TextField/TextField.js";
import { useAuthenticator as m } from "../hooks/useAuthenticator/index.js";
import { ValidationErrors as s } from "./ValidationErrors.js";
import { useStableId as l } from "../../../primitives/utils/useStableId.js";

function n(n) {
  var d = n.autocomplete,
      p = n.dialCode,
      c = n.name,
      u = n.type,
      E = e(n, ["autocomplete", "dialCode", "name", "type"]);

  var _m = m(function (_ref) {
    var e = _ref.validationErrors;
    return [e];
  }),
      b = _m.validationErrors,
      f = r.useMemo(function () {
    return t(b[c]);
  }, [c, b]),
      j = (null == f ? void 0 : f.length) > 0,
      v = l(),
      F = j ? v : void 0;

  return "tel" === u ? r.createElement(r.Fragment, null, r.createElement(i, Object.assign({}, E, {
    name: c,
    defaultDialCode: p,
    dialCodeName: "country_code",
    autoComplete: d,
    hasError: j,
    "aria-describedby": F
  })), r.createElement(s, {
    errors: f,
    id: v
  })) : "password" === u ? r.createElement(r.Fragment, null, r.createElement(o, Object.assign({}, E, {
    name: c,
    autoComplete: d,
    hasError: j,
    "aria-describedby": F
  })), r.createElement(s, {
    errors: f,
    id: v
  })) : r.createElement(r.Fragment, null, r.createElement(a, Object.assign({}, E, {
    name: c,
    autoComplete: d,
    hasError: j,
    type: u,
    "aria-describedby": F
  })), r.createElement(s, {
    errors: f,
    id: v
  }));
}

export { n as FormField };